import React from 'react';
import { Box, IconButton, Text, VStack, HStack, Circle, Button } from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';

interface OnboardingStep {
  title: string;
  description: string;
  buttonText: string;
}

interface OnboardingModalProps {
  isVisible: boolean;
  currentStep: number;
  steps: OnboardingStep[];
  onNext: () => void;
  onSkip: () => void;
  isMobile: boolean;
}

function OnboardingModal({ isVisible, currentStep, steps, onNext, onSkip, isMobile }: OnboardingModalProps) {
  if (!isVisible) return null;

  const currentStepData = steps[currentStep];

  return (
    <Box
      position={isMobile ? 'fixed' : 'absolute'}
      bottom={isMobile ? '0' : '10%'}
      right={isMobile ? '0' : '20px'}
      left={isMobile ? '0' : 'auto'}
      top={isMobile ? '0' : 'auto'}
      zIndex={9999}
    >
      <Box
        bg="white"
        borderRadius={isMobile ? '0' : '16px'}
        boxShadow={isMobile ? 'none' : '0 8px 32px rgba(0, 0, 0, 0.12)'}
        border={isMobile ? 'none' : '1px solid'}
        borderColor="gray.100"
        width={isMobile ? '100vw' : '100%'}
        maxWidth={isMobile ? '100vw' : '320px'}
        maxHeight={isMobile ? '100vh' : '500px'}
        height={isMobile ? '100vh' : '100%'}
        transition="all 0.3s ease"
        position="relative"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        {/* Botão de fechar no canto superior direito */}
        <IconButton
          aria-label="Fechar"
          icon={<FiX />}
          size="sm"
          variant="ghost"
          position="absolute"
          top="16px"
          right="16px"
          bg="purple.600"
          color="white"
          borderRadius="50%"
          _hover={{ bg: 'purple.700' }}
          onClick={onSkip}
          zIndex="1"
        />

        {/* Conteúdo centralizado */}
        <VStack spacing="32px" align="center" p="60px 24px 24px">
          {/* Ícone do equalizador centralizado */}
          <Circle size="80px" bg="pink.200" boxShadow="0 4px 20px rgba(0, 0, 0, 0.1)">
            <HStack spacing="2px">
              <Box width="3px" height="8px" bg="purple.600" borderRadius="1px" />
              <Box width="3px" height="12px" bg="purple.600" borderRadius="1px" />
              <Box width="3px" height="16px" bg="purple.600" borderRadius="1px" />
              <Box width="3px" height="12px" bg="purple.600" borderRadius="1px" />
              <Box width="3px" height="8px" bg="purple.600" borderRadius="1px" />
            </HStack>
          </Circle>

          {/* Título */}
          <Text fontWeight="bold" fontSize="24px" color="purple.600" textAlign="center" lineHeight="1.2">
            {currentStepData.title}
          </Text>

          {/* Descrição */}
          <Text fontSize="16px" color="purple.500" textAlign="center" lineHeight="1.4">
            {currentStepData.description}
          </Text>

          {/* Indicadores de progresso */}
          <HStack spacing="8px">
            {Array.from({ length: steps.length }, (_, index) => (
              <Circle
                key={index}
                size="8px"
                bg={index <= currentStep ? 'purple.600' : 'purple.200'}
                transition="all 0.3s ease"
              />
            ))}
          </HStack>

          {/* Botão de ação */}
          <Button
            variant="outline"
            borderColor="purple.600"
            color="purple.600"
            size="lg"
            width="100%"
            borderRadius="12px"
            fontWeight="semibold"
            _hover={{ bg: 'purple.50' }}
            onClick={onNext}
            position="relative"
          >
            {currentStepData.buttonText}
          </Button>

          {/* Footer */}
          <Text fontSize="12px" color="gray.400" textAlign="center">
            Powered by Nuvie
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}

export { OnboardingModal };
